// path: src/utils/sessionEnd.ts
import { resetAccessRule } from '../services/AccessRuleService';

// As mesmas chaves que o menu lateral apaga ao mandar ao login uma sessao sem usuario gravado.
export const SESSION_STORAGE_KEYS = [
  'autenticacao.response',
  'autenticacao.token',
  'autenticacao.usuarioLogin',
  'autenticacao.clientId',
  'autenticacao.clientName',
  'cliente',
  'usuario',
] as const;

const STORED_USER_KEY = 'usuario';

export const hasStoredSessionUser = (): boolean => {
  try {
    return Boolean(JSON.parse(localStorage.getItem(STORED_USER_KEY) ?? 'null')?.email);
  } catch {
    return false;
  }
};

export const clearSession = (): void => {
  resetAccessRule();
  SESSION_STORAGE_KEYS.forEach(key => localStorage.removeItem(key));
};

export const reloadPage = (): void => {
  window.location.reload();
};
